import { useFormik } from 'formik';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { LuChevronRight, LuPenLine } from 'react-icons/lu';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Badge, Box, Button, Flex, Grid, Image, Spinner, Switch, Text, useColorMode } from 'theme-ui';
import { ItemType, MediaProps, RootState } from '../../../../@types';
import { GetLatestTimeById, StartTracking, UpdateTaskAttachment, changeElapsedTime, editTaskById, getAllSubtaskSummary, getHighlighterByView, getHighlighterByViewSuccess, getTaskById, getTaskByIdSuccess, getTaskByProjectId } from '../../../store/actions/project.action';
import theme from '../../../theme';
import { baseUrl } from '../../../utils/global';
import { TaskviewCheckBox } from '../../CheckBox/TaskviewCheckBox';
import { Inputform } from '../../forms-component/InputForm';
import FormSelect from '../../forms-component/globalSelect';
import SideActions from '../../project-components/sideActions';
import plyBtn from "./playBtn.svg";
import stop from "./stop.svg";
import stopWatch from "./stopWatch.svg";
import stopWatchWhite from "./stopwatch-white.svg";
import UploadMediaFile from '../../UploadMediaFile/UploadMediaFile';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { EstimatedTimeModal } from './EstimatedTimeModal/EstimatedTimeModal';
import { useQuery } from '@tanstack/react-query';
import { getTimeDifference, millisecondsToTime, msToTime, shouldSkipApi } from '../../../utils/GenerateQueryString';
import { debounce } from 'lodash';
import TimeClosePop from './TimeClosePop/TimeClosePop';
import editIcon from "../../../Components/assets/images/edit.svg";
import { ActionModule } from '../../Actions/ActionModule/ActionModule';
import { ActionHourADay } from '../../Actions/ActionModule/ActionHourADay';
import NewDeliveryNotesModal from '../../Actions/ActionModule/NewDeliveryNotesModal';
import { removeHighlightFromTask } from '../../../store/actions/action.Highlighters';
import toast from 'react-hot-toast';
import ActionBackgroundCheck from '../../Actions/ActionModule/ActionBackgroundCheck';
import MarkDownParagraph from '../../forms-component/MarkDownParagraph';
import { IoLogOutOutline } from 'react-icons/io5';
import FolderNumberDropdown from '../createProject/StepOne/folderNumberDropdown';
import { statusColors } from '../../../utils/constent';
import { FaReply } from 'react-icons/fa';
import queryString from 'query-string';
import BCPCEstimatedTimeModal from './EstimatedTimeModal/BCPCEstimatedTimeModal';

const DoubleClickModalTask = ({ isOpen, toggle, highlight, colorMode }: any) => {
    const dispatch = useDispatch();
    const { taskId } = useParams<{ taskId: string }>();
    const handleSwitchChangeTask = () => {
        if (highlight?.name) {
            const payload = {
                highlighterName: highlight?.name
            }
            dispatch(removeHighlightFromTask(payload, taskId,));
            toggle();
        }
    };
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    return (

        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle} style={{ backgroundColor: modalHeader, color: titleHeader }}>Acknowledgement</ModalHeader>
            <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                <Box><Switch sx={{ position: 'absolute', top: '17px', right: '8px' }} onChange={handleSwitchChangeTask} /></Box>
                <Text>Are you sure you want to remove Highlighters?</Text>
            </ModalBody>

        </Modal>
    )
};

const EditTaskView: React.FC = () => {
    const location = useLocation();
    const { highlights } = queryString.parse(location.search);
    const params = new URLSearchParams(location.search);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { taskId } = useParams<{ taskId: string }>();
    const { auther } = useSelector((state: RootState) => state.auth);
    const { createprojectMasterData, loader, tasksView, sowfields, SowChecklist, elapsedTime, stageAllTaskView, highlighters: Allhighlighters, taskbyproject } = useSelector((state: any) => state.project);
    const { uploadedMedia } = useSelector((state: MediaProps) => state?.media);
    const stageId = tasksView?.stageDataId?._id;
    const projectId = tasksView?.projectId?._id;
    const { Latesttime } = useSelector((state: RootState) => state.project);
    const [Open, setOpen] = useState(false);
    const [selectedHighlight, setSelectedHighlight] = useState<any>(null);
    const [highlight, setHighlight] = useState<any>(null);
    const [description, setDescription] = useState<string>('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isModalOpen, setModalOpen] = useState(true);
    const [isDoubleClickModalOpen, setDoubleClickModalOpen] = useState<boolean>(false);
    const [isTracking, setIsTracking] = useState<any>(null);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
    const [timeTaken, setTimeTaken] = useState(0);
    const [highlighters, setHighlighters] = useState<object[]>([]);
    const [checkListItem, setCheckListItem] = useState<{ default: boolean, _id: string }[]>([]);
    const [estimatedOpen, setEstimatedOpen] = useState(false)

    const standardTasks = useMemo(() => {
        return (
            taskbyproject?.filter((task: any) => {
                const isStandard =
                    task?.taskId?.name?.toLowerCase().includes('standard');
                const isSameStage =
                    task?.stageId?._id === tasksView?.stageId?._id;
                const isNotDelivered = task?.status !== 'Delivered';

                return isStandard && isSameStage && isNotDelivered;
            }) || []
        );
    }, [taskbyproject, tasksView?.stageId?._id]);

    const [selectedTabIndex, setSelectedTabIndex] = useState<number | null>(null)

    const currentTask = selectedTabIndex !== null ? standardTasks[selectedTabIndex] : null;

    const fallbackTaskId = currentTask?.taskId?._id || tasksView?.taskId?._id;

    const SowFields = sowfields?.filter(
        (entry: any) => entry?.taskName === fallbackTaskId
    );
    const intervalRef = useRef<any>(null);
    const clickTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const [taskStatus, setTaskStatus] = useState<keyof typeof statusColors | "">("");
    const [taskDescription, setTaskDiscription] = useState("");
    const [actionObjects, setActionObjects] = useState<any>(null);
    const [spendTime, setSpendTime] = useState<any>(0);
    const [timeStatusColor, setTimeStatusColor] = useState<any>("");
    const projectManagers = createprojectMasterData?.allTaskManager || [];
    const projectWorkers = createprojectMasterData?.allTaskWorkers || [];
    const { createHighlight } = useSelector((state: any) => state.actionHighlight);
    const lastCreateHighlightRef = useRef<any>(null);
    const defaultEditableTabIndex = useMemo(() => {
        return standardTasks?.findIndex((task: any) => task?._id === taskId);
    }, [standardTasks, taskId]);

    const isEditable = (currentTask?._id || taskId) === taskId;

    useEffect(() => {
        const defaultIndex = standardTasks.findIndex((task: any) => task?._id === taskId);
        if (defaultIndex !== -1) {
            setSelectedTabIndex(defaultIndex);
        } else {
            setSelectedTabIndex(null);
        }
    }, [standardTasks, taskId]);

    const openPopup = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };
    useEffect(() => {
        if (highlights && highlighters?.length > 0) {
            const highlightsStr = Array.isArray(highlights) ? highlights[0] : highlights;
            const matched = highlighters.find((h: any) => h.name?.toLowerCase() === highlightsStr?.toLowerCase());
            if (matched && !Open && selectedHighlight?.name !== (matched as any).name) {
                handleHighlightClick(matched, true);
            }
        }
    }, [highlights, highlighters, Open, selectedHighlight]);
    useEffect(() => {
        if (tasksView?.status) {
            setTaskStatus(tasksView?.status);
        }
    }, [tasksView?.status])
    useEffect(() => {
        if (tasksView?.description) {
            setTaskDiscription(tasksView?.description);
        }
    }, [tasksView?.status])
    const estimatedClose = () => {
        setEstimatedOpen(false);
    };

    const debouncedDispatch = debounce(
        (fieldName: string, value: any, selectedTaskId: string) => {
            dispatch(editTaskById({ [fieldName]: value }, selectedTaskId, fieldName));
            formik.setFieldValue(fieldName, value, false);
        },
        500
    );
    const debounceRequest = useCallback(
        (fieldName: string, value: any) => {
            const selectedTaskId = currentTask?._id || taskId;
            if (selectedTaskId) {
                debouncedDispatch(fieldName, value, selectedTaskId);
            }
        },
        [currentTask, taskId]
    );

    useEffect(() => {
        const tasksId = currentTask?._id || taskId;
        if (tasksId) {
            dispatch(getTaskById(tasksId));
        }
    }, [currentTask, dispatch, taskId]);

    useEffect(() => {
        return () => {
            debouncedDispatch.cancel()
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (projectId && stageId && taskId) {
            setActionObjects({ projectId, stageId, taskId });
        }
    }, [projectId, stageId, taskId]);

    useEffect(() => {
        if (createHighlight && createHighlight !== lastCreateHighlightRef.current && taskId) {
            lastCreateHighlightRef.current = createHighlight;
            dispatch(getTaskById(taskId));
        }
    }, [createHighlight, dispatch, taskId]);

    useEffect(() => {
        dispatch(getTaskById(taskId));
        if (projectId) {
            dispatch(getTaskByProjectId(projectId))
        }
    }, [dispatch, taskId, projectId]);
    useEffect(() => {
        if (actionObjects) {
            dispatch(getAllSubtaskSummary(actionObjects))
        }
    }, [actionObjects])

    useEffect(() => {
        if (uploadedMedia !== null || timeTaken) {
            dispatch(getTaskById(taskId));
        }
    }, [uploadedMedia, timeTaken])

    useEffect(() => {
        dispatch(getHighlighterByView("task"));
        return () => {
            dispatch(getHighlighterByViewSuccess([]));
            dispatch(getTaskByIdSuccess([]));
        }
    }, [])

    const handleEditClick = () => {
        setIsEditing(true);
    };
    const handleSaveClick = () => {
        debounceRequest('description', description);
        setIsEditing(false);
    };
    const handleCancelClick = () => {
        setDescription(tasksView?.description || '');
        setIsEditing(false);
    };
    useQuery({
        queryKey: ['taskView', taskId],
        queryFn: () => {
            dispatch(GetLatestTimeById(taskId))
            setModalOpen(true);
        },
        refetchOnWindowFocus: true,
        staleTime: 0
    })
    const closeModal = () => {
        // Check if we came from a notification
        const prevRoute = sessionStorage.getItem('prevRoute');
        if (params.get('isNotification') === 'true') {
            if (params.get('fromTab') === 'new') {
                navigate('/dashboard');
            } else if (prevRoute) {
                navigate(prevRoute);
                sessionStorage.removeItem('prevRoute');
            } else {
                navigate(-1);
            }
        } else {
            navigate(-1);
        }
        setModalOpen(false);
    };

    const toggleDoubleClickModal = () => {
        setDoubleClickModalOpen(!isDoubleClickModalOpen);
    };
    useEffect(() => {
        // Initialize checkedItems with initially checked items from tasksView.sowMapping
        if (tasksView && tasksView.highlighters) {
            setHighlighters(tasksView.highlighters);

        }
    }, [tasksView.highlighters, tasksView.sowMapping]);
    useEffect(() => {

        if (tasksView && tasksView.highlighters) {

            setDescription(tasksView.description || '');
        }
    }, [tasksView.description, tasksView.highlighters]);

    useEffect(() => {
        if (SowChecklist?.length > 0 && checkListItem?.length == 0) {
            setCheckListItem(SowChecklist?.filter((entry: any) => entry?.taskType === tasksView?.taskId?._id))
        }
    }, [SowChecklist, tasksView])
    useEffect(() => {
        if (checkListItem?.length > 0) {
            let defaultSelectedCheckboxes;
            if (tasksView?.sowMapping?.length > 0) {
                defaultSelectedCheckboxes = tasksView?.sowMapping
            } else {
                defaultSelectedCheckboxes = checkListItem?.filter((value) => value?.default)?.map((val) => val._id)
            }

            setSelectedCheckboxes(defaultSelectedCheckboxes)
        }
    }, [checkListItem]);
    const handleCheckboxChange = (isChecked: boolean, item: ItemType) => {
        const itemId = item._id;
        let checkBox = [...selectedCheckboxes];
        if (isChecked) {
            checkBox.push(itemId)
        } else {
            checkBox = checkBox?.filter((val) => val !== itemId)
        }
        setSelectedCheckboxes(checkBox)
        dispatch(editTaskById({ "sowMapping": checkBox }, taskId, "sowMapping"))
    };

    const handleTextareaChange = (event: any) => {
        setDescription(event.target.value);
    };

    useEffect(() => {
        if (Latesttime?.startTime && taskId === Latesttime?.taskId && Latesttime?.userId?._id === auther?._id) {
            setIsTracking(true)
        } else {
            setIsTracking(false)
        }
    }, [Latesttime]);
    useEffect(() => {
        if (tasksView?.timeRemaining) {
            setSpendTime(tasksView.timeRemaining);
        }
    }, [tasksView?.timeRemaining])
    useEffect(() => {
        if (isTracking) {
            intervalRef.current = setInterval(() => {
                const newFormatTime = millisecondsToTime(getTimeDifference(Latesttime?.startTime));
                setSpendTime((time: any) => time - 1000)
                dispatch(changeElapsedTime(newFormatTime));
            }, 1000);
        } else if (intervalRef.current) {
            setIsTracking(false)
            clearInterval(intervalRef.current);
        }

        // Cleanup on unmount
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isTracking]);
    useEffect(() => {
        if (spendTime) {
            timeStatuses(spendTime)
        }
    }, [spendTime])
    const timeStatuses = (spendTime: any) => {
        if (spendTime > 0) {
            const completed = Math.floor(spendTime / tasksView?.timeEstimate * 100);
            if (completed > 30) {
                setTimeStatusColor('#56F000')
            } else if (completed < 30 && completed > 15) {
                setTimeStatusColor('#FCE83A')
            } else if (completed < 15 && completed > 5) {
                setTimeStatusColor('#FFB302');
            } else if (completed < 5) {
                setTimeStatusColor('#FF3838');
            } else {
                console.log("Not a Color!");

            }
        }

    }
    // Check for BC/PC/Rev highlighters
    const hasBCPCRevHighlighter = (tasksView?.highlighters || []).some((h: any) => ["Background Change", "Plan Check", "Revision"].includes(h.name));
    const [showBCPCModal, setShowBCPCModal] = useState(false);

    const handleStartTracking = ({ isStartedNormal = false }: any) => {
        // Always open modal if BC/PC/Rev/Revision highlighter exists
        if (!isStartedNormal && (tasksView?.highlighters || []).some((h: any) => ["Background Change", "Plan Check", "Revision", "Background Change InProgress", "Background Change Done"].includes(h.name))) {
            setShowBCPCModal(true);
            return;
        }
        const isEstimateRequired = tasksView?.status === "IPR" || tasksView?.status === "Req Time Estimate";
        const hasValidTime = tasksView?.timeEstimate > 0 && tasksView?.timeRemaining > 0;

        if (hasValidTime || (isEstimateRequired && tasksView?.timeEstimate <= 0 && tasksView?.timeRemaining <= 0)) {
            clearInterval(intervalRef.current);
            dispatch(changeElapsedTime("00:00:00"));
            const payload = {
                projectId: tasksView?.projectId?._id,
                stageId: tasksView?.stageDataId?._id,
                taskId: tasksView?._id,
                category: 'Task timer'
            };

            dispatch(StartTracking(payload));
            if (isStartedNormal) {
                setShowBCPCModal(false);
            }
        } else {
            toast.error("To begin tracking, please add a time estimate.", {
                duration: 4000,
            });
        }
    };


    const handleStopTracking = () => {
        if (isTracking !== null) {
            clearInterval(intervalRef.current);
            setIsTracking(null);
        }
        openPopup();
    };
    const handleSseChange = (data: { [key: string]: any }) => {
        Object.keys(data)?.forEach((element: string) => {
            if (element === "sowMapping") {
                setSelectedCheckboxes(data[element]);
            }
            if (element === "status") {
                setTaskStatus(data[element] as keyof typeof statusColors);

                if (tasksView.status !== data[element]) {
                    dispatch(getTaskById(taskId));
                }
            }
            if (element === "description") {
                setTaskDiscription(data[element]);
            }
            if (element === "highlighters") {
                handleHighlightersUpdate(data[element]);
            }

            formik.setFieldValue(`${element}`, data[element], true);
        });
    }
    const handleHighlightersUpdate = (data: any) => {
        setHighlighters((prev) => Array.isArray(data) ? [...data] : [])
    }

    const { data: eventSource } = useQuery({
        queryKey: ['taskSSE', taskId],
        queryFn: () => {
            const eventSource = new EventSource(`${baseUrl}sse/${taskId}`);

            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    handleSseChange(data);
                    dispatch(UpdateTaskAttachment(data.attachments))
                } catch (error) {
                    console.error('Error parsing SSE data:', error);
                }
            };

            eventSource.onerror = (error) => {
                console.error('SSE Error:', error);
                eventSource.close();
            };
            return eventSource;
        },
        refetchInterval: 60000
    })
    useEffect(() => {
        return () => {
            eventSource?.close();
            clearInterval(intervalRef.current);
        };
    }, [])

    const formik = useFormik(
        {
            enableReinitialize: true,
            initialValues: {
                description: tasksView?.description || "",
                manager: tasksView?.manager || '',
                name: tasksView?.name,
                folderNumber: tasksView?.projectId?.folderNumber,
                projectId: {
                    _id: tasksView?.projectId?._id,
                    name: tasksView?.projectId?.name
                },
                taskFields: tasksView?.taskFields || [{}],
                worker: tasksView?.worker || '',
                _id: tasksView?._id
            },
            onSubmit: () => { }
        }
    );
    const { handleSubmit, setFieldValue, handleBlur, touched, values, errors } = formik;
    const { hours, minutes, seconds } = msToTime(tasksView?.timeRemaining)

    // implement Highlight

    const handleHighlightClick = (highlight: any, autoTrigger = false) => {

        if (autoTrigger) {
            // bypass double-click logic
            const backgroundChangeGroups = ["Background Change Done", "Background Change InProgress"];
            const blockedBytradeGroup = ["Blocked By Trade Completed", "Waiting for Trade"];
            const finalReview = tasksView?.highlighters.find((highlight: any) => highlight?.name === "Final Review");
            const todoPerReview = tasksView?.highlighters.find((highlight: any) => highlight?.name === "Todo Per Review");

            let newSelectedHighlight = { ...highlight };

            if ((finalReview?.name === "Final Review" && todoPerReview?.name === "Todo Per Review") &&
                ["Todo Per Review", "Final Review"].includes(highlight.name)) {
                newSelectedHighlight = Allhighlighters?.find((item: any) => item?.name === "Final Review");
            } else if (highlight?.name === "Todo Per Review") {
                newSelectedHighlight = Allhighlighters?.find((item: any) => item?.name === "Internal Review");
            } else {
                newSelectedHighlight = backgroundChangeGroups.includes(highlight?.name)
                    ? { ...highlight, name: "Background Change" }
                    : blockedBytradeGroup.includes(highlight?.name)
                        ? { ...highlight, name: "Blocked By Trade" }
                        : highlight;
            }

            if (highlight?.name === "Needed Info Reply") {
                newSelectedHighlight = Allhighlighters?.find((item: any) => item?.name === "Need Info");
            }

            setSelectedHighlight(newSelectedHighlight);
            setOpen(true);
            return;
        }

        // existing click / double-click logic
        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
            const dblclickHighlights = ['Background Change', 'Background Change InProgress', 'Background Change Done', 'Revision', 'Plan Check',
                'New Info Added', 'Need Info', 'Needed Info Reply', 'Internal Review', 'Todo Per Review', 'Final Review', 'Ready To Deliver',
                'Hour a Day', 'Blocked By Trade', 'Waiting for Trade', 'Blocked By Trade Completed', 'Blocked by Info',
                'Delivery Notes', ' Deliver', 'Project Setup', ' Waiting for Payment - FULL', ' Waiting for Payment - PRELIM',];
            setHighlight(dblclickHighlights?.includes(highlight?.name) ? { ...highlight } : highlight);
            setDoubleClickModalOpen(true);
        } else {
            clickTimeoutRef.current = setTimeout(() => {
                clickTimeoutRef.current = null;
                handleHighlightClick(highlight, true); // 🔁 reuse logic as single-click
                const backgroundChangeGroups = ["Background Change Done", "Background Change InProgress"];
                const blockedBytradeGroup = ["Blocked By Trade Completed", "Waiting for Trade"];
                const finalReview = tasksView?.highlighters.find((highlight: any) => highlight?.name === "Final Review")
                const todoPerReview = tasksView?.highlighters.find((highlight: any) => highlight?.name === "Todo Per Review")

                let newSelectedHighlight = { ...highlight };

                if ((finalReview?.name === "Final Review" && todoPerReview?.name === "Todo Per Review") && ["Todo Per Review",
                    "Final Review"].includes(highlight.name)) {
                    newSelectedHighlight = Allhighlighters?.find((item: any) => item?.name === "Final Review");
                } else if (highlight?.name === "Todo Per Review") {
                    newSelectedHighlight = Allhighlighters?.find((item: any) => item?.name === "Internal Review");
                } else {
                    newSelectedHighlight = backgroundChangeGroups.includes(highlight?.name)
                        ? { ...highlight, name: "Background Change" }
                        : blockedBytradeGroup.includes(highlight?.name)
                            ? { ...highlight, name: "Blocked By Trade" }
                            : highlight;
                }
                if (highlight?.name === "Needed Info Reply") {
                    newSelectedHighlight = Allhighlighters?.find((item: any) => item?.name === "Need Info");
                }

                setSelectedHighlight(newSelectedHighlight);
                setOpen(true);
            }, 300);
        }
    };

    const taskIndex = stageAllTaskView?.findIndex((task: any) => {
        if (selectedHighlight?.name === "Blocked By Trade") {
            const nameList = task?.highlighters?.map((item: any) => item.name);
            if (nameList.includes(selectedHighlight?.name)) return true;
        } else {
            return task._id === taskId;
        }
    }) + 1;
    const customProps_ = {
        selectedHighlight, Open, setOpen, hourADay: tasksView?.hoursADay, actionObject: { projectId: tasksView?.projectId?._id, stageId: tasksView?.stageDataId?._id, taskId: tasksView?._id }, activeTab: taskIndex, taskStatus: tasksView?.status, TaskView: stageAllTaskView?.map((el: any) => ({ id: el._id, ...el }))
    }
    const cursorPointerGroups = ["Hour a Day", "Internal Review", 'Todo Per Review', 'Blocked by Info', "Delivery Notes", 'Ready To Deliver', ' Deliver',
        "Blocked By Trade", 'Blocked By Trade Completed', ' Waiting for Payment - FULL', ' Waiting for Payment - PRELIM',
        'Waiting for Trade', "Need Info", "New Info Added", "Final Review", "Plan Check", "Revision", "Background Change", "Background Change Done", "Background Change InProgress", "Needed Info Reply"];
    // Disable Estimated Time button if BC/PC/Rev highlighter exists
    const estimateTimeHandler = () => {
        if (isTracking) {
            toast.dismiss();
            toast.error("Time tracking in progress, So manage estimated time are disabled.", {
                duration: 4000,
            });
        } else {
            setEstimatedOpen(true);
        }
    }

    const lastUpdatedField = useRef<string | null>(null);
    const lastSubmittedValues = useRef<Record<string, string>>({});
    const handleEnter = (
        event: React.KeyboardEvent<HTMLInputElement>,
        sowfield: any,
        values: any,
        currentTask: any,
        lastSubmittedValues: React.MutableRefObject<Record<string, string>>,
        lastUpdatedField: React.MutableRefObject<string | null>,
        debounceRequest: (fieldName: string, value: string) => void
    ) => {
        if (event.key !== 'Enter') return;

        const fieldName = `taskFields.0.${sowfield?.fieldName}`;
        const newValue = values?.taskFields?.[0]?.[sowfield?.fieldName]?.trim() ?? '';
        const persistedValue =
            currentTask?.taskFields?.[0]?.[sowfield?.fieldName]?.trim() ?? '';
        const lastSubmitted = lastSubmittedValues?.current[fieldName];

        if (newValue === persistedValue || (lastSubmitted !== undefined && newValue === lastSubmitted)) {
            return;
        }

        lastSubmittedValues.current[fieldName] = newValue;
        lastUpdatedField.current = fieldName;
        debounceRequest(fieldName, newValue);
    };

    const [colorMode] = useColorMode();
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "black" : "#dadada";
    const label = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    const handleFieldBlur = (
        event: React.FocusEvent<HTMLInputElement>,
        sowfield: any,
        values: any,
        currentTask: any,
        lastSubmittedValues: React.MutableRefObject<Record<string, string>>,
        lastUpdatedField: React.MutableRefObject<string | null>,
        debounceRequest: (fieldName: string, value: string) => void,
        handleBlur: (e: any) => void,
        shouldSkipApi: (args: { input: HTMLInputElement; newValue: string; persistedValue: string }) => boolean
    ) => {
        const fieldName = `taskFields.0.${sowfield?.fieldName}`;
        const input = event.target as HTMLInputElement;

        const newValue = values?.taskFields?.[0]?.[sowfield?.fieldName]?.trim() ?? '';
        const persistedValue =
            currentTask?.taskFields?.[0]?.[sowfield?.fieldName]?.trim() ?? '';
        const lastSubmitted = lastSubmittedValues?.current[fieldName];

        if (shouldSkipApi({ input, newValue, persistedValue })) {
            handleBlur(event);
        } else if (lastUpdatedField.current === fieldName) {
            lastUpdatedField.current = null;
            handleBlur(event);
        } else if (newValue === persistedValue) {
            handleBlur(event);
        } else if (lastSubmitted !== undefined && newValue === lastSubmitted) {
            handleBlur(event);
        } else {
            lastSubmittedValues.current[fieldName] = newValue;
            debounceRequest(fieldName, newValue.trim());
            handleBlur(event);
        }
    };
    return (
        <>
            (
            <Modal isOpen={isModalOpen} scrollable toggle={closeModal} centered style={{ maxWidth: '93%', backgroundColor: modalHeader }}>
                <ModalHeader style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <Grid gap={2} columns={[2, '2.2fr auto']} sx={{ width: "100%" }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: "wrap",
                                gap: '8px',
                                alignItems: 'center',
                            }}
                        >
                            <Flex sx={{
                                gap: '8px',
                                alignItems: 'center',
                            }}>
                                <Link style={{ color: titleHeader }} to={`/edit-project/${tasksView?.projectId?._id}`}>{tasksView?.projectId?.name}</Link>
                                <LuChevronRight />{' '}
                                <Link style={{ color: colorMode === 'dark' && tasksView?.stageDataId?.color === '#000000' ? '#dadada' : tasksView?.stageId?.color }} to={`/edit-stages/${tasksView?.stageDataId?._id}`} >{tasksView?.stageDataId?.temporaryName || tasksView?.stageId?.name || ''}</Link>
                                <LuChevronRight />{' '}
                                <Link to={''} style={{ color: colorMode === 'dark' && tasksView?.taskId?.color === '#000000' ? '#dadada' : tasksView?.taskId?.color }}>{tasksView?.name}</Link>
                            </Flex>
                            <Flex sx={{
                                gap: '8px',
                                alignItems: 'center',
                            }}>
                                {highlighters?.map((badge: any) => {

                                    // Check if this badge is "Waiting For Trade"
                                    const isWaiting = badge.name === 'Waiting for Trade';

                                    // Find the task with "Blocked By Trade"
                                    const blockedByTradeTask = stageAllTaskView?.find((task: any) =>
                                        task?.highlighters?.some((h: any) => h.name === 'Blocked By Trade')
                                    );

                                    // Get the color of that blocked task
                                    const blockedTaskColor = blockedByTradeTask?.taskId?.color;

                                    // Determine dynamic badge color
                                    const badgeColor =
                                        isWaiting && blockedTaskColor
                                            ? blockedTaskColor
                                            : badge?.name === 'Needed Info Reply'
                                                ? tasksView?.taskId?.color ?? badge?.color
                                                : badge?.color;

                                    return (
                                        <Badge
                                            key={badge?._id}
                                            color={badgeColor}
                                            sx={{
                                                backgroundColor: 'transparent',
                                                borderRadius: "8px",
                                                gap: '3px',
                                                padding: '4px 8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                border: `1px solid ${badgeColor}`,
                                                cursor: `${cursorPointerGroups.includes(badge.name) ? "pointer" : "default"}`
                                            }}
                                            onClick={(e: any) => {
                                                handleHighlightClick(badge);
                                            }}
                                        >
                                            {!isWaiting && (
                                                badge?.name === 'Needed Info Reply' ? (
                                                    <FaReply
                                                        title={badge.name}
                                                        style={{ color: badgeColor }}
                                                    />
                                                ) : (
                                                    <Image
                                                        title={badge.name}
                                                        src={badge?.icon}
                                                        alt={badge?.name}
                                                        width={14}
                                                        height={14}
                                                    />
                                                )
                                            )}
                                            <Text sx={{ color: badgeColor }}>{badge?.name}</Text>
                                        </Badge>
                                    );
                                })}

                            </Flex>
                        </Box>
                        <Flex sx={{ justifyContent: 'end', gap: '0.5rem', alignItems: "center" }}>
                            <Button variant='startButton' onClick={estimateTimeHandler} disabled={taskStatus === 'IPR Ready To Deliver' || (tasksView?.highlighters || []).some((h: any) => ["Background Change", "Plan Check", "Revision", "Background Change InProgress"].includes(h.name))} sx={{
                                backgroundColor: (props) => (taskStatus === 'IPR Ready To Deliver' ? '#ccc' : 'white'), background: colorMode === "light" ? "#fff" : "transparent"
                            }}>
                                <img src={stopWatch} alt='' />
                                {hours ? `${hours} hrs` : "00"} {Number(minutes) > 0 && `${minutes} min`} {Number(seconds) > 0 && `${seconds} sec`} pending/{msToTime(tasksView?.timeEstimate)?.hours || '00'} hrs {msToTime(tasksView?.timeEstimate)?.minutes || '00'} min<img src={plyBtn} alt='' />
                            </Button>
                            {(isTracking && Latesttime?.userId?._id === auther?._id) ?
                                <>
                                    <Button variant='stopButton' sx={{ background: colorMode === "light" ? "#fff" : "transparent" }} onClick={handleStopTracking}><img src={stop} className='me-2' />Stop</Button>
                                    <Button variant='timetrack'>
                                        <img src={stopWatchWhite} alt='' /> {elapsedTime}
                                    </Button>
                                </>
                                : <>
                                    <Button variant='startButton' onClick={handleStartTracking} disabled={taskStatus === 'IPR Ready To Deliver' || taskStatus === 'IPR Delivered'} sx={{
                                        backgroundColor: (props) => (taskStatus === 'IPR Ready To Deliver' || taskStatus === 'IPR Delivered' ? '#ccc' : 'white'), background: colorMode === "light" ? "#fff" : "transparent"
                                    }}>
                                        <img src={stopWatch} alt='' /> Start Tracking <img src={plyBtn} alt='' />
                                    </Button>
                                </>
                            }
                            {loader && <Spinner size={30} className='mx-2' />}
                            <button type="button" className="btn-close mx-2" aria-label="Close" onClick={closeModal}></button>

                        </Flex>
                    </Grid>
                    <Box >
                        <Badge
                            sx={{
                                backgroundColor: `${statusColors[taskStatus as keyof typeof statusColors] || `${theme?.colors?.muted}`}`,
                                border: `1px solid ${statusColors[taskStatus as keyof typeof statusColors] || `${theme?.colors?.muted}`}`,
                                borderRadius: '8px',
                                padding: '4px 8px',
                                color: 'white',
                                fontWeight: 'bold',
                                textAlign: 'center'
                            }}
                        >
                            {taskStatus}
                        </Badge>

                        {tasksView?.trelloId && <a target='_blank' href={`https://trello.com/c/${tasksView?.trelloId}`} style={{
                            position: 'absolute',
                            right: "20px",
                            width: "150px",
                            background: "#7743db",
                            color: "#ffffff",
                            textDecoration: "none",
                            padding: "5px",
                            marginTop: "4px",
                            borderRadius: "5px",
                            textAlign: "center",
                            fontSize: "large"
                        }}>{"Go to Trello"}<IoLogOutOutline className='ms-2 fs-3' /></a>}
                    </Box>
                </ModalHeader>
                <ModalBody className="p-0" style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <>
                        <Flex sx={{ flexDirection: 'row' }}>
                            <Box sx={{ width: '65%', maxHeight: '845px', overflow: 'auto' }}>
                                <Box className="p-3">
                                    <Box className="p-3">
                                        <TaskviewCheckBox
                                            selectedData={selectedCheckboxes}
                                            title={''}
                                            Option={checkListItem}
                                            onChange={(isChecked: boolean, item: ItemType) => handleCheckboxChange(isChecked, item)}
                                        />

                                    </Box>
                                </Box>
                                <Box className="p-3">
                                    <Flex sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Text variant="SelectLabel" sx={{ color: label }}>Description</Text>
                                        {!isEditing && colorMode === 'light' ? (
                                            <Image
                                                src={editIcon}
                                                sx={{ cursor: 'pointer', width: '24px', height: '24px' }}
                                                onClick={handleEditClick}
                                            />
                                        ) : <LuPenLine style={{ cursor: 'pointer', width: '24px', height: '24px', color: 'white' }} onClick={handleEditClick} />}
                                    </Flex>
                                    {isEditing ? (
                                        <>
                                            <textarea
                                                className="form-control"
                                                value={description}
                                                onChange={handleTextareaChange}
                                                placeholder="Description..."
                                                rows={description.length > 30 ? 10 : 2}
                                            />
                                            <Flex className="mt-3" sx={{ justifyContent: 'end', gap: '8px' }}>
                                                <Button
                                                    sx={{
                                                        background: 'white',
                                                        color: theme?.colors?.primary,
                                                        border: '1px solid',
                                                        textAlign: 'center',
                                                        borderRadius: '12px',
                                                    }}
                                                    onClick={handleCancelClick}
                                                >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    sx={{ background: theme?.colors?.primary, textAlign: 'center', borderRadius: '12px' }}
                                                    onClick={handleSaveClick}
                                                >
                                                    Save
                                                </Button>
                                            </Flex>
                                        </>
                                    ) : (

                                        <Box className='ps-2' sx={{ minHeight: `${description.length < 30 ? "72px" : "265px"}`, maxHeight: `${description.length > 30 ? "265px" : "72px"}`, border: "2px solid rgb(247, 239, 229)", overflowY: "auto", borderRadius: "4px" }}>

                                            <MarkDownParagraph markdown={description} />
                                        </Box>
                                    )}
                                </Box>
                                <Tabs selectedIndex={selectedTabIndex ?? undefined} onSelect={(index) => setSelectedTabIndex(index)} className="p-3">
                                    <TabList>
                                        {standardTasks?.map((task: any, index: number) => {
                                            const isSelected = selectedTabIndex === index;
                                            const taskColor = task?.taskId?.color || "#E5E7EB";
                                            return (
                                                <Tab key={task?._id || index}
                                                    style={{
                                                        color: taskColor,
                                                        borderBottom: isSelected ? `3px solid ${taskColor}` : "3px solid transparent"
                                                    }}>
                                                    {task?.taskId?.name || ''}
                                                </Tab>
                                            )
                                        }

                                        )}
                                    </TabList>
                                </Tabs>

                                <Grid className="p-3"
                                    sx={{ gap: '1rem', marginTop: 3 }}
                                    columns={[1, 2, 2, 3, 4, 4]}
                                >
                                    {SowFields?.map((sowfield: any, index: number) => (
                                        <Box key={index}>
                                            {sowfield?.type === 'select' && sowfield?.fieldName === 'Task Worker' ? (
                                                <FormSelect
                                                    Name='taskWorker'
                                                    sx={{ color: label }}
                                                    options={projectWorkers?.map((projectWorker: { FirstName: string; LastName: string; _id: any; }) => ({
                                                        label: `${projectWorker?.FirstName} ${projectWorker?.LastName}`,
                                                        value: projectWorker?._id
                                                    })) || []}
                                                    label={sowfield?.fieldName}
                                                    placeholder={sowfield?.fieldName}
                                                    disabled={!isEditable}
                                                    value={values?.worker?._id || values?.worker}
                                                    onBlur={handleBlur}
                                                    onChange={(selectedOption: any) => {
                                                        setFieldValue(`worker`, selectedOption?.value || '');
                                                        debounceRequest('worker', selectedOption?.value);
                                                    }}
                                                />
                                            ) : sowfield?.type === 'select' && sowfield?.fieldName === 'Task Manager' ? (
                                                <FormSelect
                                                    Name='taskManager'
                                                    sx={{ color: label }}
                                                    options={projectManagers.map((projectManager: { FirstName: any; LastName: string; _id: any; }) => ({
                                                        label: `${projectManager?.FirstName} ${projectManager?.LastName}`,
                                                        value: projectManager?._id
                                                    })) || []}
                                                    placeholder={sowfield?.fieldName}
                                                    label={sowfield?.fieldName}
                                                    onBlur={handleBlur}
                                                    disabled={!isEditable}
                                                    value={values?.manager?._id || values?.manager}
                                                    onChange={(selectedOption: any) => {
                                                        setFieldValue(`manager`, selectedOption?.value || '');
                                                        debounceRequest('manager', selectedOption?.value);
                                                    }}
                                                />
                                            ) : (
                                                <Inputform

                                                    type={sowfield?.type}
                                                    label={sowfield?.fieldName}
                                                    Placeholder={sowfield?.fieldName}
                                                    Name={`tasksView.taskFields[${sowfield?.fieldName}]`}
                                                    Title_sx={{ color: 'grey' }}
                                                    sx={{ backgroundColor: !isEditable && colorMode === 'light' ? '#f2f2f2' : '', color: label }}
                                                    values={values?.taskFields?.[0]?.[sowfield?.fieldName] || []}
                                                    disabled={!isEditable}
                                                    OnChange={(event: any) => {
                                                        const newName = event.target.value;
                                                        const fieldName = `taskFields.0.${sowfield?.fieldName}`;
                                                        setFieldValue(fieldName, newName, true);
                                                    }}
                                                    onKeyDown={(e) =>
                                                        handleEnter(
                                                            e,
                                                            sowfield,
                                                            values,
                                                            currentTask,
                                                            lastSubmittedValues,
                                                            lastUpdatedField,
                                                            debounceRequest
                                                        )
                                                    }

                                                    onBlur={(e: any) =>
                                                        handleFieldBlur(
                                                            e,
                                                            sowfield,
                                                            values,
                                                            currentTask,
                                                            lastSubmittedValues,
                                                            lastUpdatedField,
                                                            debounceRequest,
                                                            handleBlur,
                                                            shouldSkipApi
                                                        )
                                                    }

                                                />

                                            )}
                                        </Box>
                                    ))}
                                    <Box>
                                        <FolderNumberDropdown
                                            sx={{ color: label }}
                                            label={"Folder Number"}
                                            value={values?.folderNumber}
                                            onBlur={handleBlur}
                                            onChange={(selectedFolderNumber: any) => {
                                                setFieldValue("folderNumber", selectedFolderNumber, true);
                                                if (!loader) {
                                                    debounceRequest('folderNumber', selectedFolderNumber);
                                                }
                                            }}

                                            disable={true}
                                        />

                                    </Box>
                                </Grid>
                                {/* <Tabs className="p-3"> */}
                                <Tabs className="p-3">
                                    <TabList>
                                        <Tab>Details</Tab>
                                    </TabList>
                                    <TabPanel>
                                        <UploadMediaFile mediaData={tasksView?.attachments || []} typeId={{
                                            task_id: taskId || '', stage_id: stageId || '', project_id: projectId || '',
                                        }} type="task" loader={loader} id={taskId} />
                                    </TabPanel>
                                </Tabs>

                            </Box>
                            <SideActions isTracking={isTracking} elapsedTime={elapsedTime} timeTaken={timeTaken} timeEstimate={tasksView?.timeEstimate} taskId={taskId} stageId={stageId} projectId={projectId} threads={tasksView.threads
                            } timeStatusColor={timeStatusColor} />
                        </Flex>
                    </>
                    <TimeClosePop isPopupOpen={isPopupOpen} closePopup={closePopup} setTimeTaken={setTimeTaken} colorMode={colorMode} />
                </ModalBody>

            </Modal >
            )
            <EstimatedTimeModal timeTaken={tasksView?.timeSpend} timeEstimate={tasksView?.timeEstimate || '00'} estimatedOpen={estimatedOpen} estimatedClose={estimatedClose} isTracking={isTracking} />
            {showBCPCModal && (
                <BCPCEstimatedTimeModal
                    timeTaken={tasksView?.timeSpend}
                    timeEstimate={tasksView?.timeEstimate || '00'}
                    estimatedOpen={showBCPCModal}
                    estimatedClose={() => setShowBCPCModal(false)}
                    isTracking={isTracking}
                    status={taskStatus}
                    handleStartTracking={handleStartTracking}
                />
            )}
            {selectedHighlight?.name === "Hour a Day" && <ActionHourADay {...customProps_} keys={{ first: "blockingTaskId" }} />}
            {selectedHighlight?.name === "Internal Review" && <ActionModule {...customProps_} keys={{ first: "isChecked" }} />}
            {selectedHighlight?.name === "Delivery Notes" && <NewDeliveryNotesModal showModal={Open} setShowModal={setOpen} {...customProps_} keys={{ first: "isChecked", second: "isInternal", fourth: "toDisplay" }} />}
            {selectedHighlight?.name === "Blocked By Trade" && <ActionModule {...customProps_} keys={{ first: "isChecked", second: "blockingTaskId" }} />}
            {selectedHighlight?.name === "Need Info" && <ActionModule {...customProps_} keys={{ first: "isChecked", second: "isBlockByInfo", fourth: "toDisplay" }} />}
            {selectedHighlight?.name === "Needed Info Reply" && <ActionModule {...customProps_} keys={{ first: "isChecked", second: "isBlockByInfo", fourth: "toDisplay" }} />}
            {selectedHighlight?.name === "New Info Added" && <ActionModule {...customProps_} keys={{ first: "isChecked" }} handleHighlightClick={handleHighlightClick} />}
            {selectedHighlight?.name === "Final Review" && <ActionModule {...customProps_} keys={{ first: "isChecked" }} />}
            {selectedHighlight?.name === "Todo Per Review" && <ActionModule {...customProps_} keys={{ first: "isChecked" }} />}
            {selectedHighlight?.name === "Plan Check" && <ActionBackgroundCheck {...customProps_} keys={{ first: "isChecked", second: "isInternal" }} showAddNewButton={false} />}
            {selectedHighlight?.name === "Revision" && <ActionBackgroundCheck {...customProps_} keys={{ first: "isChecked", second: "isInternal" }} showAddNewButton={false} />}
            {selectedHighlight?.name === "Background Change" && <ActionBackgroundCheck {...customProps_} keys={{ first: "isChecked" }} showAddNewButton={false} />}
            <DoubleClickModalTask isOpen={isDoubleClickModalOpen} toggle={toggleDoubleClickModal} highlight={highlight} colorMode={colorMode} />

        </>
    );
};

export default EditTaskView;
